import React, { useState } from 'react';
import { useGameStore } from '../store/gameStore';
import { districtPlayoffSpots, playoffQualifyText, rulesForState } from '../sim/stateRules';
import { calculateDistrictStandings } from '../sim/districtEngine';
import { AllDistrictsStandingsView } from './AllDistrictsStandingsView';
import { StandingsList } from './ui/StandingsList';

export const DistrictStandingsView: React.FC = () => {
  const { districtTeams, league, userTeamId } = useGameStore();
  const [showAll, setShowAll] = useState(false);
  const rules = rulesForState(league?.state);
  const standings = calculateDistrictStandings(districtTeams, districtPlayoffSpots(rules));
  const districtCount = league?.regions.reduce((n, r) => n + r.districts.length, 0) ?? 4;
  const { playoffs } = rulesForState(league?.state);
  const split = !!league?.splitDivisions && playoffs.divisionSplit === 'TOP_ENROLLMENT_HALF';
  const bracketSize = districtCount * (split ? playoffs.qualifiersPerDistrict / playoffs.divisionNames.length : playoffs.qualifiersPerDistrict);
  const qualifyText = playoffs.format !== 'DISTRICT_FINISH'
    ? playoffQualifyText(rulesForState(league?.state))
    : split
    ? `Top ${playoffs.qualifiersPerDistrict} teams qualify; they are split by enrollment into the ${playoffs.divisionNames.join(' and ')} state playoffs, ${bracketSize} teams each.`
    : `Top ${playoffs.qualifiersPerDistrict} teams qualify for the ${bracketSize}-team state tournament.`;

  if (showAll) return <AllDistrictsStandingsView onBack={() => setShowAll(false)} />;

  return (
    <div className="ui-screen" style={{ maxWidth: '900px' }}>
      <p className="ui-muted" style={{ margin: '0 0 12px 0' }}>
        {qualifyText} Tiebreakers cap point differential at &plusmn;17 per game.
      </p>
      <StandingsList rows={standings} highlightTeamId={userTeamId} />
      {league && league.regions.some((r) => r.districts.length > 1) && (
        <button className="ui-btn ui-btn-block" style={{ marginTop: '12px' }} onClick={() => setShowAll(true)}>
          View all {rules.districtLabel.toLowerCase()} standings →
        </button>
      )}
    </div>
  );
};
